/* unplugin-vue-components disabled */import { render } from "./Tabs.vue?vue&type=template&id=54dc4316&ts=true"
import script from "./Tabs.vue?vue&type=script&lang=ts"
export * from "./Tabs.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\openclawprogram\\sdjk123-vue - Copy - Copy\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__